import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const loginModule = {
        isLoading: false,
        init() {
            $(document).on('click', '.login-get-pincode-btn', this, this.getPinCode);
            $(document).on('click', '.login-btn', this, this.login);
        },
        login(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;

            $('.login-form').find('.form-control').removeClass('is-invalid');
            $('.login-form').find('.form-check-input').removeClass('is-invalid');
            
            var errors = false;

            if ($('#login_email').val() == '') {
                $('#login_email').addClass('is-invalid');
                errors = true;
            }
            if ($('#login_pin_code').val() == '') {
                $('#login_pin_code').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&email=' + encodeURIComponent($('#login_email').val());
            values += '&pin_code=' + encodeURIComponent($('#login_pin_code').val());
            $.ajax({
                type: "POST",
                url: baseURL + "/login",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#login_"+errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

                        Swal.fire({
                            html: response.message
                        });

                        return false;
                    }

                    if (response.status == 1) {

                        window.location = response.data.redirect_url

                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });
		},
		getPinCode(event) {
			const _this = event.data;
			event.preventDefault();
            var element = this;

            $('.login-form').find('.form-control').removeClass('is-invalid');
            $('.login-form').find('.form-check-input').removeClass('is-invalid');
            
            var errors = false;

            if ($('#login_email').val() == '') {
                $('#login_email').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
			$(element).find('i').show();

            var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
            values += '&email=' + encodeURIComponent($('#login_email').val());
            $.ajax({
                type: "POST",
                url: baseURL + "/login/pincode",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#login_"+errorKey).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }

                        Swal.fire({
                            html: response.message
                        });

                        return false;
                    }

                    if (response.status == 1) {

                        $('.login-pin-code-wrapper').show();
                        $(element).find('span').text($(element).data('login-text'));
                        $(element).removeClass('login-get-pincode-btn').addClass('login-btn');

                        Swal.fire({
                            text: response.message
                        });

                        return;
                    }

                    Swal.fire({
                        text: response.message
                    });
                },
                error: function() {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                }
            });
		}
    };

    if ($('.login-container').length) {
        loginModule.init();
    }
});
